module.exports = __webpack_public_path__ + "images/signup_header.4b8591e9.jpg";